import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { trackAddToCart } from '../utils/metaPixel';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 9,
    seconds: 0
  });
  useEffect(() => {
    // Check if we have an end time in localStorage
    let endTime = localStorage.getItem('boticaOfferEndTime');
    if (!endTime) {
      // Set end time to 24 hours from now
      const newEndTime = new Date().getTime() + 9 * 60 * 1000;
      localStorage.setItem('boticaOfferEndTime', newEndTime.toString());
      endTime = newEndTime.toString();
    }
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = parseInt(endTime!) - now;
      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({
          minutes: 0,
          seconds: 0
        });
        // Optional: you could reset it here if you want it to loop,
        // but typically countdowns stay at 0
      } else {
        setTimeLeft({
          minutes: Math.floor(distance / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section id="comprar" className="py-10 px-4 bg-white" data-id="element-165">
      <div className="max-w-2xl mx-auto" data-id="element-166">
        <FadeIn data-id="element-167">
          <div className="bg-cream p-5 md:p-8 rounded-2xl shadow-2xl border-4 border-amber/30 text-center relative overflow-hidden" data-id="element-168">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-amber/10 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-169"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-sage/10 rounded-full blur-2xl -ml-10 -mb-10" data-id="element-170"></div>

            <div className="relative z-10" data-id="element-171">
              <h2 className="text-2xl md:text-3xl font-bold text-brown-dark mb-2" data-id="element-172">
                Su Inversión Hoy
              </h2>

              <div className="mb-4" data-id="element-173">
                <p className="text-base text-brown-light line-through mb-1" data-id="element-174">
                  Valor real: $19.97 USD
                </p>
                <div className="flex items-center justify-center text-4xl md:text-5xl font-bold text-terracotta-dark font-serif" data-id="element-175">
                  <span className="text-3xl mr-3" data-id="element-176">🌿</span>
                  Solo $6.39 <span className="text-xl ml-2 mt-2" data-id="element-177">USD</span>
                </div>
                <p className="text-base text-brown font-medium mt-2 bg-white/50 inline-block px-4 py-1 rounded-full" data-id="element-178">
                  Menos que una taza de café en Starbucks.
                </p>
              </div>

              <div className="bg-white rounded-xl p-4 mb-4 text-left max-w-md mx-auto shadow-sm border border-cream-dark" data-id="element-179">
                <ul className="space-y-1.5" data-id="element-180">
                  {['Descarga instantánea en PDF', '100% en Español', 'Compatible con celular, tableta o computadora', 'Imprimible si prefiere tenerlo físico'].map((item, i) => <li key={i} className="flex items-center text-brown text-sm font-medium" data-id="element-181">
                      <span className="text-sage mr-2" data-id="element-182">✅</span>
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="bg-terracotta/10 rounded-xl p-4 mb-4 border border-terracotta/20" data-id="element-183">
                <p className="text-terracotta-dark font-bold text-base mb-2 flex items-center justify-center" data-id="element-184">
                  <span className="text-xl mr-2" data-id="element-185">⏰</span> OFERTA LIMITADA
                </p>
                <p className="text-brown text-sm mb-3" data-id="element-186">
                  Este precio especial de $6.39 USD termina en:
                </p>

                <div className="flex justify-center space-x-3 mb-3" data-id="element-187">
                  <div className="bg-white text-terracotta-dark font-bold text-2xl md:text-3xl w-16 h-16 flex items-center justify-center rounded-xl shadow-inner border border-terracotta/20" data-id="element-188">
                    {formatTime(timeLeft.minutes)}
                  </div>
                  <div className="text-2xl font-bold text-terracotta self-center" data-id="element-189">
                    :
                  </div>
                  <div className="bg-white text-terracotta-dark font-bold text-2xl md:text-3xl w-16 h-16 flex items-center justify-center rounded-xl shadow-inner border border-terracotta/20" data-id="element-190">
                    {formatTime(timeLeft.seconds)}
                  </div>
                </div>

                <p className="text-xs text-brown-light italic" data-id="element-191">
                  Después de este tiempo, el precio regresa a $19.97 USD.
                </p>
              </div>

              <div onClick={trackAddToCart} data-id="element-192">
                <Button href="https://mibienestarlatino.com/cart/45925952094369:1" className="w-full text-lg py-4 shadow-xl shadow-terracotta/20" data-id="element-193">
                  Quiero mi copia ahora por $6.39 USD
                </Button>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}